/**
 * Account deletion UX: phrase user must type in dialog before confirming (with username).
 */

/** Lowercase prefix; full phrase is `${DELETE_PHRASE_PREFIX}${normalizedUsername}`. */
export const DELETE_PHRASE_PREFIX = 'delete ' as const

/**
 * Normalizes for comparison (trim + lowercase).
 */
export function normalizeDeletePhraseInput(value: string): string {
  return value.trim().toLowerCase()
}

/**
 * Expected phrase after normalization (user types lowercase).
 */
export function buildExpectedDeletePhrase(username: string): string {
  const u = username.trim().toLowerCase()
  return `${DELETE_PHRASE_PREFIX}${u}`
}

export const ACCOUNT_DELETE_DIALOG = {
  TITLE: 'Delete account?',
  MESSAGE:
    'This permanently removes your account and associated data. This cannot be undone. Type the phrase below to confirm.',
  CONFIRM: 'Delete account',
  CANCEL: 'Cancel',
  INPUT_HINT: (username: string) => `Type: ${DELETE_PHRASE_PREFIX}${username.trim().toLowerCase()}`,
  USERNAME_MISSING: 'Could not load your username. Pull to refresh or try again later.',
} as const
